import { FunctionComponent } from 'react';

import { Flex, Text, Image } from '@chakra-ui/react';

type FooterProps = {};

const Footer: FunctionComponent<FooterProps> = ({ children }) => (
    <Flex
        h='80px'
        position='relative'
        style={{
            borderTopLeftRadius: '25px',
            borderTopRightRadius: '25px',
            boxShadow: '2px 2px 8px gray',
        }}
        bg='blue.500'
        alignItems='center'
        justifyContent='center'
    >
        <a href='https://knobs.it/blockchain/' target='_blank'>
            <Flex flexDirection='row' alignItems='center'>
                <Text color='white'>Powered by </Text>
                <Image src='/images/logo-knobs-bianco.png' h='50px' />
            </Flex>
        </a>
        {children}
    </Flex>
);

export default Footer;
